export default "__VITE_ASSET__WJPLB5Zu__"